"use strict";
'use client';
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var apps_shared_1 = require("@l2p/apps-shared");
var swr_hooks_1 = require("@l2p/swr-hooks");
var ui_components_1 = require("@l2p/ui-components");
var next_intl_1 = require("next-intl");
var navigation_1 = require("next/navigation");
var react_1 = __importStar(require("react"));
var PromocodeApplied_1 = __importDefault(require("./PromocodeApplied"));
var PromocodeInvalid_1 = __importDefault(require("./PromocodeInvalid"));
var PromocodeNotApplied_1 = __importDefault(require("./PromocodeNotApplied"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var AddPromocode = function (_a) {
    var _b, _c, _d;
    var _e = _a.needVefiryEmail, needVefiryEmail = _e === void 0 ? false : _e;
    var breakpoints = (0, apps_shared_1.useBreakpoint)();
    var isEmailVerificationEnabled = (0, swr_hooks_1.useGetIsEmailVerificationEnabled)().data;
    var userData = (0, swr_hooks_1.useUser)().data;
    var isEmailVerified = isEmailVerificationEnabled
        ? (_d = (_c = (_b = userData === null || userData === void 0 ? void 0 : userData.profile) === null || _b === void 0 ? void 0 : _b.getOne) === null || _c === void 0 ? void 0 : _c.profile) === null || _d === void 0 ? void 0 : _d.emailVerified
        : true;
    var openEmailVerify = (0, apps_shared_1.useOpenEmailVerify)();
    var searchParams = (0, navigation_1.useSearchParams)();
    var _f = (0, react_1.useState)(''), promocode = _f[0], setPromocode = _f[1];
    var _g = (0, react_1.useState)(''), promocodeInput = _g[0], setPromocodeInput = _g[1];
    var promocodeRef = (0, react_1.useRef)(null);
    var _h = (0, react_1.useState)(false), isOpenPromocodeInvalid = _h[0], setIsOpenPromocodeInvalid = _h[1];
    var _j = (0, react_1.useState)(false), isOpenPromocodeApplied = _j[0], setIsOpenPromocodeApplied = _j[1];
    var _k = (0, react_1.useState)(false), isOpenPromocodeNotApplied = _k[0], setIsOpenPromocodeNotApplied = _k[1];
    var t = (0, next_intl_1.useTranslations)();
    var _l = (0, swr_hooks_1.useGetPromocodeByCode)(promocode), data = _l.data, isLoading = _l.isLoading, isValidating = _l.isValidating;
    var _m = (0, swr_hooks_1.useActivatePromocode)({
        successAction: function () {
            setIsOpenPromocodeApplied(true);
        },
        errorAction: function () {
            setIsOpenPromocodeNotApplied(true);
        },
    }), activatePromocode = _m.activatePromocode, isSubmitting = _m.isSubmitting;
    var onApplyPromocode = (0, react_1.useCallback)(function () {
        var _a;
        setPromocode((_a = promocodeRef === null || promocodeRef === void 0 ? void 0 : promocodeRef.current) === null || _a === void 0 ? void 0 : _a.value);
    }, [promocodeRef]);
    (0, react_1.useEffect)(function () {
        var _a, _b;
        if ((_a = data === null || data === void 0 ? void 0 : data.promos) === null || _a === void 0 ? void 0 : _a.getPromoByCode) {
            activatePromocode({ basePromoId: data.promos.getPromoByCode });
        }
        else if (((_b = data === null || data === void 0 ? void 0 : data.promos) === null || _b === void 0 ? void 0 : _b.getPromoByCode) === null) {
            setIsOpenPromocodeInvalid(true);
        }
    }, [data]);
    (0, react_1.useEffect)(function () {
        if (searchParams) {
            var giftcodeParam = searchParams.get('giftcode');
            if (giftcodeParam) {
                setPromocodeInput(giftcodeParam);
            }
        }
    }, [searchParams]);
    return (react_1.default.createElement("section", { className: styles_module_scss_1.default.container }, !isEmailVerified ? (react_1.default.createElement("div", { className: styles_module_scss_1.default.verifyEmail },
        react_1.default.createElement("div", null,
            react_1.default.createElement("h1", null, t('emailVerification.verifyToEnterTitle')),
            react_1.default.createElement("p", null, t('emailVerification.verifyToEnterText'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.verifyButton },
            react_1.default.createElement(ui_components_1.FixedButton, { type: "button", color: "gradient", text: "upper", height: "42px", maxWidth: "100%", onClick: openEmailVerify },
                react_1.default.createElement("span", null, t('emailVerification.verifyBtn')))))) : (react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.inner) },
        react_1.default.createElement("div", null,
            react_1.default.createElement("h1", null,
                t('translation.addPromoCode'),
                ' ',
                breakpoints.mobile && t('translation.andReceiveBonus')),
            !breakpoints.mobile && react_1.default.createElement("p", null, t('translation.andReceiveBonus'))),
        react_1.default.createElement("div", { className: styles_module_scss_1.default.inputWrapper },
            react_1.default.createElement(ui_components_1.InputText, { innerRef: promocodeRef, name: promocodeInput || '', value: promocodeInput, labelText: t('translation.inputGiftcodeLabel'), onChange: function (e) { return setPromocodeInput(e.target.value); } }),
            promocodeInput && (react_1.default.createElement("div", { className: styles_module_scss_1.default.button },
                react_1.default.createElement(ui_components_1.FixedButton, { type: "button", color: "gradient", text: "upper", disabled: !promocodeInput, loading: isValidating || isSubmitting || isLoading, height: "24px", maxWidth: "max-content", onClick: onApplyPromocode }, t('translation.confirm'))))),
        isOpenPromocodeInvalid && (react_1.default.createElement(PromocodeInvalid_1.default, { onClose: function () { return setIsOpenPromocodeInvalid(false); } })),
        isOpenPromocodeApplied && (react_1.default.createElement(PromocodeApplied_1.default, { onClose: function () { return setIsOpenPromocodeApplied(false); } })),
        isOpenPromocodeNotApplied && (react_1.default.createElement(PromocodeNotApplied_1.default, { onClose: function () { return setIsOpenPromocodeNotApplied(false); } }))))));
};
exports.default = AddPromocode;
